<template>
    <div>
        <!-- Modal Entrega de Material -->
        <div class="modal fade" id="listaEntregaMaterialModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Entregar Material</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12 col-md-9">
                                <az-input 
                                    placeholder="Selecionar paciente..."
                                    icon="fas fa-user"
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    service="pacientes.index"
                                    optionsDisplay="search"
                                    ref="info_paciente"
                                    v-model="paciente" 
                                    :optimized_ac="true"
                                    @selecionado="buscar_atendimentos(apenas_pendentes)">
                                </az-input> 
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input   
                                    type="checkbox-group"
                                    label="Apenas Pendentes"
                                    v-model="apenas_pendentes"
                                    @input="buscar_atendimentos(apenas_pendentes)" />
                            </div>
                        </div>

                        <div class="mt-3">
                            <div v-if="lista_entrega.length">
                                <ul class="list-group">
                                    <li class="list-group-item" v-for="(atd, iax) in lista_entrega" :key="iax">
                                        <div class="form-row">
                                            <div class="col col-12 col-md-3">
                                                <div>
                                                    <a href="#" @click.prevent="verColeta(atd)" class="card-link h5">
                                                        #{{ atd.id_atendimento }}
                                                    </a>
                                                </div>
                                                <div>{{ $util.getFormatDate(atd.dt_inicio) }}</div>
                                            </div>
                                            <div class="col col-12 col-md-9">
                                                <celula-dados-procedimento 
                                                    :hor="{ marcacao: atd }" 
                                                    :lab="true" 
                                                    :blockanexos="true"
                                                    callback_filtrar2="filtrar" />
                                            </div>
                                        </div>
                                    </li>
                                </ul>

                                <pre v-if="false">{{ entrega }}</pre>
                            </div>

                            <az-empty-state v-else :msg="!paciente ? 'Selecione o Paciente...' : 'Nenhum atendimento identificado.'" />
                        
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import CelulaDadosProcedimento from '../../shared/table/CelulaDadosProcedimento.vue';

export default {
    data() {
        return { 
            apenas_pendentes: true, 
            paciente: "",
            entrega: null,
            outro: null, 
        };
    },

    components: { 
        AzInput, 
        AzEmptyState, 
        CelulaDadosProcedimento, 
    }, 

    computed: { 
        lista_entrega: function ()  { 
            if ( !this.entrega || !this.entrega.lista || !this.entrega.lista.length ) { 
                return [];
            }

            return this.entrega.lista; 
        },
    },

    methods: { 
        abrir (outro = null) { 
            this.paciente = "";
            this.outro = _.cloneDeep(outro);

            $('#listaEntregaMaterialModal').modal('show');
        },

        buscar_atendimentos (apenas_pendentes = false) { 
            if ( !this.paciente ) 
                return;

            this.$util.load(this, { 
                service: 'amostras',
                func: 'coleta',
                parms: { 
                    id_paciente: this.paciente.id_pessoa,
                    apenas_pendentes: apenas_pendentes, 
                },  
                loadTo: res => { 
                    this.entrega = res;
                }
            });
        },

        verColeta (item) { 
            $('.modal').modal('hide');

            if ( this.outro ) { 
                item.id_atendimento_outro = this.outro.id_atendimento_outro;
            }

            this.$emit('verColeta', item);
        },
    }
}
</script>
